import { render, staticRenderFns } from "./InvoiceUploader.vue?vue&type=template&id=0ca47b70"
import script from "./InvoiceUploader.vue?vue&type=script&lang=js"
export * from "./InvoiceUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports